<template>
  <div ref="TreeChart" style="width: 100%; height: 100%" @wheel.prevent></div>
</template>

<script>
import * as echarts from "echarts";
import { px2rem } from "@/utils/rem";
import { generateTreeChartTooltip } from "@/utils/tooltip";

export default {
  name: "TreeChartTwo",
  emits: ["chart-click", "finished"],
  data() {
    return {
      chart: null,
      chartData: [],
    };
  },
  mounted() {
    // this.init();
  },
  methods: {
    init() {
      let option = {
        tooltip: {
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor: "transplant",
          borderColor: "transplant",
          borderWidth: 0,
          padding: 0,
          formatter: function (params) {
            return generateTreeChartTooltip({
              name: params.name,
              value: params.value,
              primaryColor: params.color,
              borderColor: params.color,
            });
          },
        },
        series: [
          {
            type: "tree",
            data: this.chartData,
            roam: true,
            top: "10px",
            left: "100px",
            bottom: "10px",
            right: "200px",
            initialTreeDepth: 2,
            symbolSize: px2rem(14),
            labelLayout: {
              hideOverlap: true,
            },
            label: {
              width: px2rem(200),
              position: "left",
              verticalAlign: "middle",
              align: "right",
              fontSize: px2rem(14),
            },
            leaves: {
              label: {
                width: px2rem(200),
                position: "right",
                verticalAlign: "middle",
                align: "left",
              },
            },
            emphasis: {
              focus: "descendant",
            },
            animationDuration: 550,
            animationDurationUpdate: 750,
          },
        ],
      };
      this.chart = echarts.init(
        this.$refs.TreeChart,
        {},
        {
          renderer: "svg",
        }
      );
      this.chart.setOption(option);
      // 注册树状图的点击事件
      this.chart.on("click", (params) => {
        console.log(params);
        /*[
            {
              "name": "",
              "dataIndex": 0
            },
            {
              "name": "放线菌",
              "dataIndex": 1
            },
            {
              "name": "TF",
              "dataIndex": 2
            },
            {
              "name": "Basic Domians group",
              "dataIndex": 9
            },
            {
              "name": "OmpR",
              "dataIndex": 12
            },
            {
              "name": "PhoP",
              "dataIndex": 13,
              "value": 1
            }
          ]
        */
        // 找到当前点击的节点在树状图中的层级
        const index = params.treeAncestors.findIndex(
          (item) => item.name === params.name
        );
        this.$emit("chart-click", {
          name: params.data.name,
          index: index,
          treeAncestors: params.treeAncestors
            .slice(2, index + 1)
            .map((item, index) => ({
              ...item,
              level: 2 + index,
            })),
        });
      });
      this.chart.on("dblclick", (params) => {
        if (!params.data.children) {
          // 找到当前点击的节点在树状图中的层级
          const index = params.treeAncestors.findIndex(
            (item) => item.name === params.name
          );
          this.$emit("chart-click-leaf", {
            name: params.data.name,
            index: index,
            treeAncestors: params.treeAncestors
              .slice(2, index + 1)
              .map((item, index) => ({
                ...item,
                level: 2 + index,
              })),
          });
        }
      });
      this.chart.on("finished", () => {
        this.$emit("finished");
        this.chart.off("finished");
      });
    },
    setData(data) {
      this.chartData = data;
      this.chart && this.chart.dispose();
      this.init();
    },
  },
  beforeDestroy() {
    // 在组件销毁前，销毁 ECharts 实例
    this.chart && this.chart.dispose();
  },
};
</script>

<style lang="scss" scoped></style>
